'use client'

import { useActionState } from 'react'
import { useTranslation } from 'react-i18next'
import { type CustomerioSignUpState } from '@/features/customerioSignUp/customerioSignUp.server'
import { Button } from 'ui/src/components/Button/Button'
import { Text } from 'ui/src/components/Text/Text'
import { TextField } from 'ui/src/components/TextField/TextField'
import { yStack } from 'ui/src/patterns/stack'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { vintageShopSignUpAction } from './vintageShopSignUpAction'

export function SignUpForm() {
  const { t } = useTranslation(['vintageShop'])
  const initialState: CustomerioSignUpState = { status: 'idle' }
  const [state, formAction, isPending] = useActionState(vintageShopSignUpAction, initialState)

  const isSuccess = state.status === 'success'
  const isError = state.status === 'error'

  return (
    <form className={yStack({ gap: 'xs' })} action={formAction}>
      <TextField
        type="email"
        label={t('VINTAGE_SHOP_SIGN_UP_DIALOG_EMAIL_LABEL')}
        name="email"
        required={true}
        disabled={isSuccess}
      />

      {isError && <Text color="textPrimary">{t('VINTAGE_SHOP_SIGN_UP_DIALOG_ERROR')}</Text>}

      {isSuccess ? (
        <Button type="button" size="large" fullWidth={true} variant="primary">
          {t('VINTAGE_SHOP_SIGN_UP_DIALOG_SUCCESS')}
        </Button>
      ) : (
        <Button type="submit" size="large" fullWidth={true} loading={isPending}>
          {t('VINTAGE_SHOP_SIGN_UP_DIALOG_BUTTON')}
        </Button>
      )}

      <Text
        color="textSecondary"
        size="xs"
        align="center"
        balance={true}
        className={sprinkles({ marginTop: 'xxs', paddingInline: 'md' })}
      >
        {t('VINTAGE_SHOP_SIGN_UP_DIALOG_DISCLAIMER')}
      </Text>
    </form>
  )
}
